export default __webpack_public_path__ + "media/src/assets/images/DOT_hazmat_class_1.2-1bd1e3de32610a1453d0bafa240b41e5.svg";